import styled from 'styled-components/macro';
import { colorCoreGray700, colorCoreWhite1000, colorWhiteTransparent800 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const FooterBottomStyled = styled.div `
  position: relative;

  color: ${colorCoreWhite1000};
  direction: ${({ isRightToLeft }) => (isRightToLeft ? 'rtl' : 'ltr')};

  ${ADAPTIVE.maxWidth.tablet} {
    padding: 0 0 6px 0;
  }

  ${ADAPTIVE.maxWidth.mobile} {
    padding: 0 0 24px 0;
  }
`;
export const MiddleSectionStyled = styled.div `
  ${getTextStyles('Ubuntu', 400, 14, 24)}
  text-align: center;
  color: ${colorCoreGray700};

  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${ADAPTIVE.maxWidth.tablet} {
    align-items: normal;
    justify-content: normal;
    text-align: left;
    display: block;
    margin-top: 26px;
  }

  ${ADAPTIVE.maxWidth.mobile} {
    margin-top: 0;
  }
`;
export const RightSectionStyled = styled.div `
  display: flex;
  justify-content: end;
  gap: 16px;
  align-items: center;
  height: 100%;

  ${ADAPTIVE.maxWidth.tablet} {
    justify-content: start;

    &::before {
      margin-left: 0;
    }
  }

  a {
    ${getTextStyles('Ubuntu', 400, 14, 20)}
    text-decoration-line: underline;
    color: ${colorWhiteTransparent800};
    cursor: pointer;
  }
`;
